import React from "react";
import { Link } from "react-router-dom";
import { htmlToExcerpt } from "../../utils/sanitizeHtml";

/**
 * Learning Q&A teaser for feed and board.
 */
export default function QuestionCard({
  post,
  linkPrefix = "/home/question",
  compact = false,
  interactive = true,
}) {
  const excerpt = htmlToExcerpt(post.content || post.text || "", compact ? 90 : 160);
  const replies = Number(post.reply_count || 0);
  const photoCount = Array.isArray(post.media)
    ? post.media.filter((m) => {
        const type = String(m?.type || m?.media_type || "").toLowerCase();
        const url = String(m?.url || m?.media_url || "");
        return (
          type.startsWith("image") ||
          /\.(jpe?g|png|gif|webp|bmp|svg|avif|heic|heif)$/i.test(url)
        );
      }).length
    : 0;
  const canLink = interactive && !!linkPrefix;
  const Wrapper = canLink ? Link : "div";
  const wrapperProps = canLink
    ? {
        to: `${linkPrefix}/${post.id}`,
        style: { textDecoration: "none", color: "inherit", display: "block" },
      }
    : { style: { color: "inherit", display: "block" } };

  return (
    <div style={{ marginTop: compact ? 0 : 4 }}>
      <Wrapper {...wrapperProps}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.4,
            textTransform: "uppercase",
            color: "#b45309",
            background: "#fef3c7",
            padding: "3px 8px",
            borderRadius: 4,
            marginBottom: 8,
          }}
        >
          Q&A
          {post.category ? (
            <span style={{ fontWeight: 600, color: "#92400e", textTransform: "none", letterSpacing: 0 }}>
              · {post.category}
            </span>
          ) : null}
        </div>
        <h3
          style={{
            fontSize: compact ? 15 : 20,
            fontWeight: 700,
            color: "#102a43",
            margin: "0 0 6px",
            lineHeight: 1.3,
          }}
        >
          {post.title || "Untitled question"}
        </h3>
        {excerpt && (
          <p
            style={{
              margin: "0 0 8px",
              fontSize: compact ? 12 : 14,
              color: "#475569",
              lineHeight: 1.45,
            }}
          >
            {excerpt}
          </p>
        )}
        <p
          style={{
            margin: 0,
            fontSize: compact ? 11 : 12,
            color: "#64748b",
            fontWeight: 600,
          }}
        >
          {replies === 0
            ? "No answers yet — be the first"
            : `${replies} answer${replies === 1 ? "" : "s"}`}
          {photoCount > 0
            ? ` · ${photoCount} photo${photoCount === 1 ? "" : "s"}`
            : ""}
          {canLink ? " · View discussion →" : ""}
        </p>
      </Wrapper>
    </div>
  );
}
